'use strict';

import {
  initManager,
  isSubmenuVisible,
  removeSubmenuButtons,
  showSubmenuIconsAndButtons
} from '@jspartials/menu-utils';

function getSubmenuInfo() {
  const assetsListContainer = document.querySelector('[data-assets-list]');

  // Sin megamenú (p.ej. site in-store sin slot de menú configurado) no hay
  // nada que consultar: se evita leer dataset de un elemento inexistente.
  if (!assetsListContainer) {
    return;
  }

  const params = new URLSearchParams();
  params.append('assetsList', assetsListContainer.dataset.assetsList);

  fetch(`${globalVariables.endpoint.submenuInfo}?${params.toString()}`, {
    method: 'GET'
  })
    .then((response) => {
      if (!response.ok) {
        console.log('error');
      } else {
        response.json().then((data) => {
          const submenuAssetsInfo = data.assetsContent;

          Object.keys(submenuAssetsInfo).forEach((key) => {
            sessionStorage.setItem(key, JSON.stringify(submenuAssetsInfo[key]));
            !isSubmenuVisible(submenuAssetsInfo[key]) &&
              removeSubmenuButtons(key);
          });

          showSubmenuIconsAndButtons();
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

export const initMenu = () => {
  getSubmenuInfo();
  initManager();
};

document.addEventListener('DOMContentLoaded', initMenu);
